import { Module } from "vuex";
import { RootState } from "../types";
import { InfoCandidate } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  data: [],
} as InfoCandidate;

export const candidateInfo: Module<InfoCandidate, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
